module.exports = __webpack_public_path__ + "img/medium.523a7c3f.svg";